import {
	AlertDialog,
	BulletList,
	FormattedText,
	Typography
} from "client/Components";
import { useDataInputDialog } from "client/Hooks";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement, useCallback } from "react";

export type UserGroupPermissionExplanationDialogProps = {
	onClose: () => void;
};

export const UserGroupPermissionExplanationDialog = (
	props: UserGroupPermissionExplanationDialogProps
): ReactElement => {
	const {
		onClose
	} = props;

	return (
		<AlertDialog
			trackingId="user-group-permissions-info-dialog"
			title={localize("_Permissions")}
			onClose={onClose}
			showCloseButton
		>
			<BulletList
				trackingId="points"
				rowGap="large"
			>
				<BulletList.Item>{localize("_UserGroupPermissionInfoPart1")}</BulletList.Item>
				<BulletList.Item>
					<FormattedText
						text={localize("_UserGroupPermissionInfoPart2")}
						thingsToReplace={[
							{
								what: "{{Allow}}",
								filler: (
									<Typography weight="bold">
										{localize("_Allow")}
									</Typography>
								)
							},
							{
								what: "{{Deny}}",
								filler: (
									<Typography weight="bold">
										{localize("_Deny")}
									</Typography>
								)
							}
						]}
					/>
				</BulletList.Item>
				<BulletList.Item>
					<FormattedText
						text={localize("_UserGroupPermissionInfoPart3")}
						thingsToReplace={[
							{
								what: "{{NotSet}}",
								filler: (
									<Typography weight="bold">
										{localize("_NotSet")}
									</Typography>
								)
							}
						]}
					/>
				</BulletList.Item>
			</BulletList>
		</AlertDialog>
	);
};
UserGroupPermissionExplanationDialog.displayName = "UserGroupPermissionExplanationDialog";

export function useUserGroupPermissionExplanationDialog(): [
	element: ReactElement | null,
	open: () => Promise<void>
] {
	const [element, originalOpen] = useDataInputDialog<{}, void>(
		(props, onClose) => (
			<UserGroupPermissionExplanationDialog
				{...props}
				onClose={onClose}
			/>
		)
	);

	const open = useCallback(
		async (): Promise<void> => {
			await originalOpen({});
		},
		[originalOpen]
	);

	return [element, open];
}
